Template.prototype.clearEventMaps = function clearEventMaps() {
  this.__eventMaps = [];
};
